import { useEffect, useState } from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import CategoryForm from '../category/CategoryForm';
import CategoriesApi from '../../api/CategoriesApi';
import Category from "../../model/Category";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import { toggleOpenMainSideBar } from "../../../core/functions";
import NotesCount from "../../model/NotesCount";

const CategoriesMenu = () => {
    // const dispatch = useDispatch();

    const [showModal, setShowModal] = useState(false);
    const [activeCategory, setActiveCategory] = useState<number|null>(null);
    const handleCloseModal = () => setShowModal(false);
    const handleShowModal = () => setShowModal(true);    
    const filter = useSelector((state: RootState) => state.notes.filter);
    const notesCounter:NotesCount[] = useSelector((state: RootState) => state.notes.notesCounter)

    const [categories, setCategories] = useState<Category[]>([]);

    var loadCategories = () => {
      CategoriesApi.getCategories()
        .then(data => {
            setCategories(data.content);
        })        
    }

    useEffect(()=>{
        loadCategories();
    }, []);

    useEffect(() => {
      if(filter && 'categoryId' in filter) {
          setActiveCategory(filter['categoryId'])
      } else {
          setActiveCategory(null)
      }
    }, [filter])

    const getCountNotesInCategory = (categoryId:number|null|undefined) => {
        for(var i=0; i<notesCounter.length; i++) {
          if (notesCounter[i].categoryId == categoryId) {
            return notesCounter[i].count;
          }
        }
        return 0;
    }

    const getCtegoriesListItemClass = (categoryId:number) => {
      let itemClass = "list-group-item d-flex justify-content-between align-items-start";
      if(categoryId==activeCategory) {
        itemClass += " active";
      }
      return itemClass;
    }

    const CategoryModal = () => {
        return (
            <>
              <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                  <Modal.Title>
                    <FormattedMessage id="create_category"/>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CategoryForm onSaveCategory={() => {
                        loadCategories();
                        setShowModal(false);
                      }}
                      categoryId={undefined}></CategoryForm>
                </Modal.Body>
              </Modal>
            </>
          );
    }

    return (<>
        <div>
            <CategoryModal/>
        </div>
        <div className="sidebar-section-header">
            <h3><FormattedMessage id="categories"/></h3> <Button variant="primary" onClick={handleShowModal} className="btn-color btn-sm">+</Button>
        </div>        
        <div>
            <ul className="list-group">
              {categories.map(category => {
              return <li key={'category-' + category.id} 
                          className={getCtegoriesListItemClass(category.id!)}>
                <div className="ms-2 me-auto">
                  <Link to={'/notes?categoryId=' + category.id} onClick={() => toggleOpenMainSideBar(null)}>
                    {category.title}
                  </Link>
                </div>
                <span className="badge bg-primary rounded-pill">{getCountNotesInCategory(category.id)}</span>
            </li>
            })}
          </ul>
        </div>
    </>);
}

export default CategoriesMenu;